// focus-trap.js
export default {
  mounted(el) {
    // Store a reference to the parent container
    const parentContainer = el;

    // Function to get all valid focusable elements
    const getFocusableElements = () => {
      // Get all potentially focusable elements
      const allElements = parentContainer.querySelectorAll(
        "a[href], button:not([disabled]), textarea:not([disabled]), " +
          'input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), ' +
          'input[type="checkbox"]:not([disabled]), select:not([disabled]), ' +
          '[tabindex]:not([tabindex="-1"])'
      );

      // Filter to only include elements that are:
      // 1. Contained within our parent container
      // 2. Visible (not hidden by CSS)
      return Array.from(allElements).filter((element) => {
        // Check if the element is inside our container
        if (!parentContainer.contains(element)) {
          return false;
        }

        // Check if the element is visible
        const style = window.getComputedStyle(element);
        const isVisible = !(
          style.display === "none" ||
          style.visibility === "hidden" ||
          element.offsetWidth === 0 ||
          element.offsetHeight === 0
        );

        return isVisible;
      });
    };

    // Keydown handler function - defined separately so we can remove it later
    const handleKeyDown = (e) => {
      // Get the current set of focusable elements
      const focusableElements = getFocusableElements();

      // If no focusable elements, do nothing
      if (focusableElements.length === 0) {
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      // Check if current active element is within our container
      // If not within our container, we don't interfere with tab navigation
      if (!parentContainer.contains(document.activeElement)) {
        return;
      }

      // Handle tab key
      const isTabPressed = e.key === "Tab" || e.keyCode === 9;
      if (!isTabPressed) {
        return;
      }

      // Shift + Tab navigation
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      }
      // Tab navigation
      else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    };

    // Add the event listener
    el.addEventListener("keydown", handleKeyDown);

    // Store the handler for cleanup
    el._focusTrapCleanup = () => {
      el.removeEventListener("keydown", handleKeyDown);
    };
  },

  // Cleanup when directive is removed
  unmounted(el) {
    if (el._focusTrapCleanup) {
      el._focusTrapCleanup();
      delete el._focusTrapCleanup;
    }
  }
};
